'use strict';

import timestamp from './timestamp';


export default function(incident) {
	timestamp(incident);

	function Q() {
		for (var i = 0, nbArgs = arguments.length; i < nbArgs; i++) {
			var time = incident.timestamps[arguments[i]];
			if (time) return time;
		}
		return false;
	}

	if (incident.completed) {
		if (incident.state != 'completed') {
			incident.state = 'completed';
			incident.stateTime = new Date();
		}
	} else if (Q('team:global_formation_initialized')) {
		incident.state = 'formation initialized';
		incident.stateTime = incident.time;
	} else {
		incident.state = 'new';
		incident.stateTime = incident.time;
	}
}
